import React from 'react';
import EditNote from '@mui/icons-material/EditNote';
import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';

export const PROJECT_TIMELINE_MESSAGE_CONTEXT = 'PROJECT_TIMELINE_MESSAGE_CONTEXT';
export const PROJECT_NOTE_SOURCE = 'projectNote';

export const PROJECT_TIMELINE_TYPE = {
  USER_NOTE: 'USER_NOTE',
  SYSTEM_NOTE: 'SYSTEM_NOTE',
  CLOSEOUT: 'COMPLETION_PROJECT_NOTE',
};

export const PROJECT_TIMELINE_RECORD_FILTER_TYPE = {
  USER_NOTE: PROJECT_TIMELINE_TYPE.USER_NOTE,
  SYSTEM_NOTE: PROJECT_TIMELINE_TYPE.SYSTEM_NOTE,
  SUMMARY_REVIEW: 'SUMMARY_REVIEW',
};

export const PROJECT_TIMELINE_RECORD_FILTER_OPTIONS = {
  [PROJECT_TIMELINE_RECORD_FILTER_TYPE.USER_NOTE]: 'User note',
  [PROJECT_TIMELINE_RECORD_FILTER_TYPE.SYSTEM_NOTE]: 'System note',
  [PROJECT_TIMELINE_RECORD_FILTER_TYPE.SUMMARY_REVIEW]: 'Summary review',
};

export const PROJECT_NOTE_TIMELINE_ICONS: Record<string, React.ComponentType> = {
  [TimelineType.NOTE]: EditNote,
  default: EditNote,
};

export const PROJECT_SYSTEM_NOTE_TIMELINE_ICONS: Record<string, React.ComponentType> = {
  SystemNote: SettingsOutlined,
  default: SettingsOutlined,
};

export const PROJECT_SUMMARY_REVIEW_TIMELINE_ICONS: Record<string, React.ComponentType> = {
  SummaryReview: FactCheckOutlined,
  default: FactCheckOutlined,
};

export const LINK_TYPE_OPTIONS = [
  { value: 'PUBLISHED_DELIVERABLES', label: 'Published deliverables' },
  { value: 'FINAL_TECH_DOCUMENTATION', label: 'Final technical documentation' },
  { value: 'OTHER', label: 'Other' },
];

const CLOSEOUT_STATUS = {
  ENDED: 'ENDED',
  CONTINUES: 'CONTINUES',
};

export const CLOSEOUT_STATUS_OPTIONS = [
  { label: 'Project is ending', value: CLOSEOUT_STATUS.ENDED },
  { label: 'Project continues with a new SOW', value: CLOSEOUT_STATUS.CONTINUES },
];
